import { useState } from 'react';
import { Modal, ModalHeader, ModalTitle, ModalContent } from '../ui/modal';
import { Button } from '../ui/button';
import { userApi } from '../../api/user.api';

interface GenderRegisterModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const GenderRegisterModal = ({ isOpen, onClose, onSuccess }: GenderRegisterModalProps) => {
  const [selectedGender, setSelectedGender] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>('');

  const handleRegister = async () => {
    if (!selectedGender) {
      setError('성별을 선택해주세요');
      return;
    }

    setIsLoading(true);
    setError('');
    try {
      const res = await userApi.registerGender(selectedGender);
      const bonus = res.data?.bonusAmount;
      if (bonus) alert(`성별이 등록되었어요. 조각 ${bonus}개를 받았어요!`);
      onSuccess();
      onClose();
    } catch (err: any) {
      if (err.response?.status === 409) {
        setError('이미 등록된 성별은 변경할 수 없어요');
      } else {
        setError('성별 등록에 실패했습니다');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setSelectedGender('');
    setError('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalHeader>
        <ModalTitle>성별을 선택해주세요</ModalTitle>
        <p className="text-sm text-amber-600 mt-1">입력하면 조각 1개 보너스! 한번 등록하면 수정할 수 없어요</p>
      </ModalHeader>
      <ModalContent>
        <div className="space-y-3 mb-6">
          {[
            { label: '남성', value: 'MALE' },
            { label: '여성', value: 'FEMALE' },
          ].map((option) => (
            <label
              key={option.value}
              className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${
                selectedGender === option.value
                  ? 'border-primary bg-primary/5'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <input
                type="radio"
                name="gender"
                value={option.value}
                checked={selectedGender === option.value}
                onChange={(e) => setSelectedGender(e.target.value)}
                className="accent-primary"
              />
              <span className="text-sm font-medium">{option.label}</span>
            </label>
          ))}
        </div>
        {error && <p className="text-sm text-red-500 mb-4">{error}</p>}
        <div className="flex gap-2">
          <Button variant="outline" className="flex-1" onClick={handleClose} disabled={isLoading}>
            닫기
          </Button>
          <Button className="flex-1" onClick={handleRegister} disabled={!selectedGender || isLoading}>
            {isLoading ? '등록 중...' : '등록'}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default GenderRegisterModal;
